import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Permission } from 'src/app/constants/permission.constant';
import { IProduct } from 'src/app/models/products/product';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-product-link-action',
  templateUrl: './product-link-action.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ProductLinkActionComponent {
  @Input() product!: IProduct;

  Permission = Permission;

  constructor(public authService: AuthService) {}

  get isDisabled(): boolean {
    return this.product.productLink == '' || this.product.productLink == null;
  }
}
